<template>
  <div>
    <b-button
      type="is-primary"
      class="has-text-weight-bold"
      @click="openPopUp = true">
      {{$t('tableauDeBord.createRecommandation')}}
    </b-button>
    <b-modal v-model="openPopUp"
      has-modal-card>
      <modal-selection-societe
        @isSelected="createRecommandation"
      />
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import modalSelectionSociete from '@/components/general/modalSelectionSociete.vue';
import gestionErreur from '@/services/general/gestionErreur';

const User = createNamespacedHelpers('user');
const Recommandations = createNamespacedHelpers('recommandations');

export default {
  components: {
    modalSelectionSociete
  },
  data() {
    return {
      openPopUp: false,
    };
  },
  methods: {
    ...User.mapMutations({
    }),
    ...Recommandations.mapActions({
      initialierRecommandationDevis: 'initialierRecommandationDevis',
    }),
    async createRecommandation () {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.initialierRecommandationDevis();
        this.$router.push({ name: 'point-de-vente' });
      } catch (error) {
        gestionErreur(`Erreur lors de l'initialisation d'une recommandation`, error);
      } finally {
        loadingComponent.close();
      }
    },
  },
}
</script>
